export default "__VITE_ASSET__9e233331__"